import { useContext } from "react";
import { NotificationContext } from "@/context/notificationTypes";
import type { NotificationContextValue } from "@/context/notificationTypes";

export function useNotifications(): NotificationContextValue {
  const ctx = useContext(NotificationContext);
  if (!ctx) {
    throw new Error("useNotifications must be used within NotificationProvider");
  }
  return ctx;
}
